import React from 'react';
import PropTypes from 'prop-types';

import './counter.css';

const Counter = ({
  title,
  value,
  minValue,
  maxValue,
  onChange
}) => (
  <div className="counter">
    {!!title && (
      <b className="counter-title">
        {title}
      </b>
    )}

    <div className="counter-selector">
      <button
        className="counter-button"
        disabled={(typeof minValue === 'number') && (value === minValue)}
        type="button"
        onClick={() => onChange(value - 1)}
      >
        –
      </button>

      <span className="counter-value">
        {value}
      </span>

      <button
        className="counter-button"
        disabled={(typeof maxValue === 'number') && (value === maxValue)}
        type="button"
        onClick={() => onChange(value + 1)}
      >
        +
      </button>
    </div>
  </div>
);

Counter.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number.isRequired,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

Counter.defaultProps = {
  title: null,
  maxValue: null,
  minValue: null
};

export default Counter;



// WEBPACK FOOTER //
// ./src/widgets/Counter/index.js